import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-24 bg-[#070C18]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-electric-500 via-electric-600 to-[#003D99] p-12 lg:p-16 text-center">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

          <div className="relative z-10 max-w-2xl mx-auto">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 text-white text-xs font-semibold uppercase tracking-widest mb-6">
              <i className="ri-calendar-check-line"></i>
              Free 30-Minute Assessment
            </span>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-4">
              Ready to Transform Your Business?
            </h2>
            <p className="text-white/80 text-lg mb-2">
              Book a free 30-minute assessment. No commitment. No sales pressure.
            </p>
            <p className="text-white/60 text-sm mb-10">
              Just an honest conversation about where AI automation can make the biggest difference for you.
            </p>
            <Link
              className="inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-white text-electric-600 font-bold text-base hover:bg-slate-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
              to="/contact"
            >
              Book Your Free Assessment
              <i className="ri-arrow-right-line"></i>
            </Link>
            <p className="text-white/50 text-xs mt-4">Takes 2 minutes to schedule</p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mt-8">
              <div className="flex items-center gap-1.5 text-white/60 text-sm">
                <i className="ri-shield-check-line"></i>No credit card required
              </div>
              <div className="flex items-center gap-1.5 text-white/60 text-sm">
                <i className="ri-close-circle-line"></i>Cancel anytime
              </div>
              <div className="flex items-center gap-1.5 text-white/60 text-sm">
                <i className="ri-lock-2-line"></i>GDPR compliant
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
